// Engine error type — PSD §2.3. Engine layer (framework-free).
export class EngineError extends Error {
    code;
    constructor(code, message) {
        super(`${code}: ${message}`);
        this.name = 'EngineError';
        this.code = code;
    }
}
//# sourceMappingURL=error.js.map